<template>
  <header id="topbar">
    <nav id="navbar" class="navbar navbar-expand-lg">
      <!-- <div class="collapse navbar-collapse" id="navbarContent"> -->
      <p class="mb-0 my-auto font-size-16 d-none d-lg-block">
        POS - Partial Offering System
      </p>
      <!-- <topbar-dropdown /> -->
      <!-- </div> -->
    </nav>
  </header>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import EntrySearch from "@/components/VEntrySearch.vue";
// import TopbarDropdown from "@/components/TopbarDropdown.vue";
import { currentUserStore } from "@/store/typed";

@Component({ components: { EntrySearch } })
export default class TheTopbar extends Vue {
  get currentUser() {
    return currentUserStore.currentUser;
  }
}
</script>

<style lang="scss" scoped>
.user-icon {
  height: 32px;
  margin-right: 0.5rem;
}
</style>

<style lang="scss">
@import "../styles/vue";

#topbar {
  .entry-search {
    width: auto;
    flex-grow: 1;

    input {
      border: 0;
      font-size: 0.8125rem;

      &::placeholder {
        color: $gray-300;
      }
    }

    .icon {
      font-size: 0.8125rem;
      color: $secondary;
      margin-top: 1px;
    }
  }
}
</style>
